module.exports = __webpack_public_path__ + "edeab41c840bcb5c0aaf40126fb6a76e.png";